import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { UpdatePasswordContainer } from 'src/containers/auth/update-password';
import { z } from 'zod';

const resetPasswordSearchSchema = z.object({
  redirectAfterCompleteUrl: z.string().catch('/'),
  token: z.string(),
});

export const Route = createFileRoute('/(common)/reset-password')({
  component: UpdatePasswordContainer,
  validateSearch: zodValidator(resetPasswordSearchSchema),
});
